export default function NewContentBadge() {
  return <div className="badge badge-primary badge-sm">NEW</div>
};
